import { render, staticRenderFns } from "./PackagePay.vue?vue&type=template&id=defd30b4&scoped=true"
import script from "./PackagePay.vue?vue&type=script&lang=js"
export * from "./PackagePay.vue?vue&type=script&lang=js"
import style0 from "./PackagePay.vue?vue&type=style&index=0&id=defd30b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defd30b4",
  null
  
)

export default component.exports